import './App.css';
import Navbar from './layout/nav/Navbar';
import AllRoutes from './routes'

function App() {
  return (
    <div>
      <Navbar/>
      <AllRoutes/>
    </div>
  );
}

export default App;
